import React from "react";
import { Link } from "react-router-dom";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import heroImage from "assets/img/premium-logistics-hero-branded.jpg";

const trustItems = [
  { label: "Trusted & Verified", Icon: ShieldRoundedIcon },
  { label: "Fast Booking", Icon: BoltRoundedIcon },
  { label: "Real-Time Tracking", Icon: LocationOnRoundedIcon },
  { label: "Nationwide Coverage", Icon: GroupsRoundedIcon }
];

export default function HeroSection() {
  return (
    <section className="pl-hero" id="home" aria-labelledby="pl-hero-title">
      <img
        className="pl-hero__image"
        src={heroImage}
        alt="Container truck travelling through a modern Philippine port at sunrise"
        width="1774"
        height="887"
      />
      <div className="pl-hero__shade" aria-hidden="true" />
      <div className="pl-container pl-hero__inner">
        <div className="pl-hero__content">
          <p className="pl-eyebrow pl-eyebrow--light">Philippines&apos; logistics marketplace</p>
          <h1 id="pl-hero-title">
            Deliver Smarter.<br />
            Move <span>Faster.</span>
          </h1>
          <p className="pl-hero__summary">
            Connect with trusted logistics providers for your cargo, anytime, anywhere in the Philippines.
          </p>
          <div className="pl-hero__buttons">
            <Link className="pl-button pl-button--primary" to="/addbookings">
              <LocalShippingRoundedIcon aria-hidden="true" />
              Book a Shipment
              <ArrowForwardRoundedIcon aria-hidden="true" />
            </Link>
            {/* A dedicated public fleet onboarding route does not exist yet; /login contains the current signup flow. */}
            <Link className="pl-button pl-button--outline-light" to="/login">
              Become a Fleet Partner
            </Link>
          </div>
          <ul className="pl-trust-list" aria-label="Garahex service advantages">
            {trustItems.map(({ label, Icon }) => (
              <li key={label}>
                <Icon aria-hidden="true" />
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="pl-hero__aside" aria-label="Garahex commitment">
          <blockquote>&ldquo;Your Cargo<br />Our Commitment&rdquo;</blockquote>
          <div className="pl-hero__nation">
            <strong>Delivering<br />a stronger<br />Philippines<br />together</strong>
          </div>
        </div>
      </div>
    </section>
  );
}
